import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import ReviewsTable from './table';
import OverLoading from '../../global/OverLoading';
import apiService from '../../../services.js/apiService';

const Reviews = ({ match }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const onAddReview = async () => {
    try {
      setLoading(true);
      if (match && match.params) {
        const review = await apiService.addReview({ pageId: parseInt(match.params.id) });

        history.push({
          pathname: `/admin/page/${match.params.id}/review/${review.id}`,
          state:    {
            from: 'page-add-review',
          },
        });
      }
    } catch (err) {
      console.error('error adding review: ', err);
    } finally {
      setLoading(false);
    }
  };

  return loading ? <OverLoading /> : (
    <>
      <div className="row" style={{ backgroundColor: '#fff', marginLeft: 1 }}>
        <div className="col-lg-12 col-12" style={{ padding: 15 }}>
          <Button onClick={() => { onAddReview(); }} variant="contained" color="primary" size="medium">Add Review</Button>
        </div>
        <div className="col-lg-12 col-12 card-left">
          <ReviewsTable pageId={(match && match.params) ? match.params.id : ''} />
        </div>
      </div>
    </>
  );
};

Reviews.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default Reviews;
